export const startPointerDrag = (event, handlers) => {
    // Só o botão principal: o direito abre menu, o do meio rola.
    if (event.button !== 0)
        return;
    const element = event.currentTarget;
    const pointerId = event.pointerId;
    const originX = event.clientX;
    const originY = event.clientY;
    let last = { dx: 0, dy: 0 };
    let frame = 0;
    // Captura: o arraste continua mesmo com o ponteiro fora da barra de título,
    // que é onde ele fica metade do tempo num arraste rápido.
    try {
        element.setPointerCapture(pointerId);
    }
    catch {
        // Sem captura (jsdom, ponteiro já solto): os eventos ainda chegam.
    }
    const onPointerMove = (move) => {
        last = { dx: move.clientX - originX, dy: move.clientY - originY };
        if (frame !== 0)
            return;
        frame = requestAnimationFrame(() => {
            frame = 0;
            handlers.onMove(last);
        });
    };
    const finish = (cancelled) => {
        if (frame !== 0)
            cancelAnimationFrame(frame);
        frame = 0;
        element.removeEventListener('pointermove', onPointerMove);
        element.removeEventListener('pointerup', onPointerUp);
        element.removeEventListener('pointercancel', onPointerCancel);
        try {
            element.releasePointerCapture(pointerId);
        }
        catch {
            // Já solta.
        }
        if (cancelled)
            handlers.onCancel?.();
        else
            handlers.onEnd(last);
    };
    const onPointerUp = (up) => {
        last = { dx: up.clientX - originX, dy: up.clientY - originY };
        finish(false);
    };
    const onPointerCancel = () => {
        finish(true);
    };
    element.addEventListener('pointermove', onPointerMove);
    element.addEventListener('pointerup', onPointerUp);
    element.addEventListener('pointercancel', onPointerCancel);
    // Sem isto o navegador seleciona o texto do título enquanto arrasta.
    event.preventDefault();
};
//# sourceMappingURL=pointer-drag.js.map